import { secondsToMilliseconds } from 'date-fns';
import { z } from 'zod';
import { parseJwtTokenClaims } from './parseJwtTokenClaims';
const jwtTimestampClaimsSchema = z.object({
    exp: z.number().optional(),
    iat: z.number().optional(),
});
const extractToken = (token, expiresIn) => {
    const jwtClaims = parseJwtTokenClaims(token, jwtTimestampClaimsSchema);
    const jwtValidForSecs = jwtClaims?.exp && jwtClaims?.iat
        ? jwtClaims.exp - jwtClaims.iat
        : undefined;
    const validForSecs = expiresIn ?? jwtValidForSecs;
    const validForMs = validForSecs && secondsToMilliseconds(validForSecs);
    return {
        token,
        issuedAt: Date.now(),
        validForMs: validForMs ?? Number.MAX_SAFE_INTEGER,
    };
};
export const extractTokensFromResponse = (response) => {
    const { access_token: accessToken, refresh_token: refreshToken, expires_in: accessTokenExpiresIn, refresh_expires_in: refreshTokenExpiresIn, } = response;
    return {
        accessToken: extractToken(accessToken, accessTokenExpiresIn),
        refreshToken: refreshToken
            ? extractToken(refreshToken, refreshTokenExpiresIn)
            : undefined,
    };
};
